export default __webpack_public_path__ + "static/media/slide2.b7042e9d.jpg";